import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
const StarIcon = (param)=>{
    let { color = 'none', onClick, ...props } = param;
    return /*#__PURE__*/ _jsx("span", {
        className: "ibaicon",
        ...props,
        style: {
            cursor: 'pointer'
        },
        onClick: onClick,
        children: /*#__PURE__*/ _jsx("svg", {
            width: "32",
            height: "32",
            viewBox: "0 0 32 32",
            fill: color,
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ _jsx("g", {
                id: "star-01 / Outline",
                children: /*#__PURE__*/ _jsx("path", {
                    id: "Icon",
                    d: "M15.0435 4.60434C15.3508 3.98175 15.5045 3.67046 15.7131 3.571C15.8946 3.48447 16.1054 3.48447 16.2869 3.571C16.4955 3.67046 16.6492 3.98175 16.9565 4.60434L19.872 10.511C19.9628 10.6948 20.0081 10.7867 20.0744 10.858C20.1331 10.9212 20.2035 10.9724 20.2817 11.0087C20.37 11.0498 20.4714 11.0646 20.6743 11.0943L27.1959 12.0475C27.8827 12.1479 28.2261 12.1981 28.385 12.3658C28.5233 12.5118 28.5883 12.7123 28.562 12.9116C28.5317 13.1407 28.2831 13.3828 27.7859 13.8671L23.0686 18.4618C22.9215 18.605 22.848 18.6767 22.8005 18.7619C22.7585 18.8373 22.7316 18.9202 22.7212 19.0059C22.7094 19.1027 22.7268 19.2039 22.7615 19.4062L23.8746 25.8961C23.992 26.5806 24.0507 26.9228 23.9404 27.1259C23.8444 27.3026 23.6738 27.4266 23.476 27.4632C23.2488 27.5053 22.9415 27.3437 22.3268 27.0205L16.4965 23.9544C16.3148 23.8588 16.224 23.8111 16.1283 23.7923C16.0436 23.7757 15.9564 23.7757 15.8717 23.7923C15.776 23.8111 15.6852 23.8588 15.5035 23.9544L9.67319 27.0205C9.05851 27.3437 8.75117 27.5053 8.52392 27.4632C8.3262 27.4266 8.15559 27.3026 8.05961 27.1259C7.94929 26.9228 8.00799 26.5806 8.12539 25.8961L9.23847 19.4062C9.27318 19.2039 9.29053 19.1027 9.27879 19.0059C9.26839 18.9202 9.24144 18.8373 9.19943 18.7619C9.15199 18.6767 9.07846 18.605 8.93141 18.4618L4.21404 13.8671C3.71684 13.3828 3.46825 13.1407 3.43799 12.9116C3.41167 12.7123 3.4767 12.5118 3.61496 12.3658C3.77387 12.1981 4.11725 12.1479 4.80402 12.0475L11.3257 11.0943C11.5285 11.0646 11.6299 11.0498 11.7182 11.0087C11.7964 10.9724 11.8668 10.9212 11.9255 10.858C11.9918 10.7867 12.0372 10.6948 12.1279 10.511L15.0435 4.60434Z",
                    stroke: "#FFAD0A",
                    strokeWidth: "2",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                })
            })
        })
    });
};
export default StarIcon;
